import * as React from "react";
import { client } from "utils/api-client";

const AuthContext = React.createContext();
AuthContext.displayName = "AuthContext";

function AuthProvider(props) {
  const [user, setUser] = React.useState();
  const [accessToken, setAccessToken] = React.useState(() => {
    // Fetch from localStorage initially
    return localStorage.getItem("access-token")
      ? JSON.parse(localStorage.getItem("access-token"))
      : null;
  });
  const [refreshToken, setRefreshToken] = React.useState(() => {
    // Fetch from localStorage initially
    return localStorage.getItem("refresh-token")
      ? JSON.parse(localStorage.getItem("refresh-token"))
      : null;
  });
  const [userInfo, setUserInfo] = React.useState(() => {
    // Fetch from localStorage initially
    return localStorage.getItem("user-info")
      ? JSON.parse(localStorage.getItem("user-info"))
      : null;
  });

  React.useEffect(() => {
    // Fetching regions and storing them in localStorage

    const storedUserInfo = localStorage.getItem("user-info");
    let parsedUserInfo = null;
    if (storedUserInfo) {
      try {
        client("locations", { method: "GET", data: null, headers: {} })
          .then((regions) => {
            localStorage.setItem("regions", JSON.stringify(regions));
          })
          .catch((error) => {
            console.error("Error fetching regions:", error);
          });
        parsedUserInfo = JSON.parse(storedUserInfo);
      } catch (error) {
        console.error("Error parsing user-info from localStorage:", error);
      }
    }

    const user = parsedUserInfo?.data;
    setUser(user);
  }, []);

  const logout = React.useCallback(() => {
    // Clearing all localStorage items on logout
    localStorage.clear();
    setUser(null);
    setAccessToken(null);
    setRefreshToken(null);
    setUserInfo(null);
  }, []);

  const setUserInfoOnLogin = (info) => {
    console.log("setUserInfo", info);
    setUserInfo(info);
    setUser(info?.data);
    setAccessToken(info?.accessToken);
    setRefreshToken(info?.refreshToken);

    // Manually storing user-related data to localStorage
    localStorage.setItem("user-info", JSON.stringify(info));
    localStorage.setItem("access-token", JSON.stringify(info?.accessToken));
    localStorage.setItem("refresh-token", JSON.stringify(info?.refreshToken));
  };

  const value = React.useMemo(
    () => ({ logout, user, accessToken, setUserInfoOnLogin }),
    [logout, user, accessToken, setUserInfoOnLogin]
  );

  return <AuthContext.Provider value={value} {...props}></AuthContext.Provider>;
}

function useAuth() {
  const context = React.useContext(AuthContext);
  if (context === undefined) {
    throw new Error(`useAuth must be used within a AuthProvider`);
  }
  return context;
}

function useClient() {
  const { user, accessToken } = useAuth();
  return React.useCallback(
    (endpoint, config) => client(endpoint, { ...config, token: accessToken }),
    [accessToken]
  );
}

export { AuthProvider, useAuth, useClient };
